import React from 'react'
import { Controller, useFormState } from 'react-hook-form'
import { Rate } from 'antd'

const ActiveRateField = ({ field, control }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  let rateClass = ''

  if (isSubmitted) {
    rateClass = error ? 'input-error' : 'input-success' // Remplacez par vos propres classes CSS
  }

  const RateRender = ({ onChange = () => {}, value }) => (
    <Rate
      className={rateClass}
      style={input_style || {}}
      value={value}
      onChange={(value) => onChange(value)}
    />
  )

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      rules={{ required: field.required }}
      render={({ field: { onChange, value } }) => (
        <RateRender onChange={onChange} value={value} />
      )}
      defaultValue={field.VALUE__reponse || 1}
    />
  )
}

const InactiveRateField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}
  const RateRender = () => <Rate style={input_style || {}} />

  return <RateRender />
}

const RateField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveRateField field={field} control={control} />
  ) : (
    <InactiveRateField field={field} />
  )
}

export default RateField
